import styled from 'styled-components';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const wrapper = styled.div`
    ${dFlexCenter};
    gap: var(--space-sm);
    padding: 0 var(--space-md) 0 var(--space-xs);
    height: 28px;
    border-radius: 100px;
    background: var(--TA-color-bg-surface-default);
    width: fit-content;
`;

export const badge = styled.div`
    ${dFlexCenter};
    height: 18px;
    min-width: 24px;
    padding-inline: var(--space-sm);
    background: var(--TA-color-bg-base-alt);
    color: var(--TA-color-text-inverse-default);
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 18px;
    border-radius: 100px;
    flex-shrink: 0;
    box-sizing: border-box;
`;


